import { render } from "./resultados.vue?vue&type=template&id=bd2412e0&scoped=true"
import script from "./resultados.vue?vue&type=script&lang=js"
export * from "./resultados.vue?vue&type=script&lang=js"

import "./resultados.vue?vue&type=style&index=0&id=bd2412e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd2412e0"]])

export default __exports__